// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var PositionInfoType;
(function (PositionInfoType) {
    PositionInfoType[PositionInfoType["None"] = 0] = "None";
    PositionInfoType[PositionInfoType["PLByCurrency"] = 1] = "PLByCurrency";
    PositionInfoType[PositionInfoType["AverageOpenPrice"] = 2] = "AverageOpenPrice";
    PositionInfoType[PositionInfoType["BreakEven"] = 3] = "BreakEven";
    PositionInfoType[PositionInfoType["NetQTY"] = 4] = "NetQTY";
    PositionInfoType[PositionInfoType["LongQty"] = 5] = "LongQty";
    PositionInfoType[PositionInfoType["ShortQty"] = 6] = "ShortQty";
})(PositionInfoType || (PositionInfoType = {}));
